import { defineMessages } from 'react-intl'

export default defineMessages({
  title: { defaultMessage: 'All-time stats' },
  totalMade: { defaultMessage: 'Total Money Made' },
  totalReceive: { defaultMessage: 'Total Boba Received' },
})
